import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '@env/environment';
import { IBranchOperation } from 'app/models/licenses/branch-operation';
import { Observable } from 'rxjs';

@Injectable({providedIn: 'root'})
export class BranchOperationService {
  private api: string = environment.privateApi + 'BranchOperation/';
  private http = inject(HttpClient);

  public getBranchOperations(entityId: number, entityType: string, includeArchived: boolean): Observable<IBranchOperation[]>{
    return this.http.get<IBranchOperation[]>(this.api + 'GetBranchOperations/' + entityId + '/' + entityType + '/' + includeArchived);
  }

  public createBranchOperation(operation: IBranchOperation, entityType: string): Observable<IBranchOperation>{
    return this.http.post<IBranchOperation>(this.api + 'CreateBranchOperation/' + entityType, operation);
  }

  public updateBranchOperation(operation: IBranchOperation): Observable<boolean>{
    return this.http.post<boolean>(this.api + 'UpdateBranchOperation', operation);
  }

  public archiveBranchOperation(operationId: number, archive: boolean): Observable<boolean>{
    return this.http.post<boolean>(this.api + 'ArchiveBranchOperation/' + operationId + '/' + archive, null);
  }

  public deleteBranchOperation(operationId: number): Observable<boolean>{
    return this.http.delete<boolean>(this.api + 'DeleteBranchOperation/' + operationId);
  }

  public getBranchCities(entityId: number, entityType: string): Observable<string[]>{
    return this.http.get<string[]>(this.api + 'GetBranchCities/' + entityId + '/' + entityType);
  }
}
